import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';
import { AtlContactCardCarouselProps, CardTags } from './card.types.ts';
import classNames from 'classnames';
import { ifDefined } from 'lit/directives/if-defined.js';

import Styles from './contact-card-carousel.scss?inline';

@customElement(CardTags.ContactCardCarousel)
export class AtlContactCardCarousel
   extends LitElement
   implements AtlContactCardCarouselProps
{
   @property({ attribute: 'carouselClassName', type: String })
   carouselClassName?: string;

   @property({ attribute: 'contact-mail', type: String })
   contactMail: string;

   @property({ attribute: 'contact-name', type: String })
   contactName: string;

   @property({ attribute: 'contact-position', type: String })
   contactPosition: string;

   @property({ type: String })
   internalId?: string;

   @property({ type: String })
   internalClassName?: string;

   @property({ type: String })
   initials: string;

   @property({ type: String })
   cardTitle: string;

   @property({ type: String })
   avatar?: string;

   @property({ type: String })
   avatarAlt?: string;

   @property({ type: Boolean })
   fixedSize?: boolean;

   @property({ type: Boolean })
   hasViewTeamCallback: boolean;

   static styles = [
      ...getGlobalStyleSheets(),
      Styles
   ];

   render() {
      return html`
         <div
            class=${classNames('carousel', this.carouselClassName)}
            part="contact-card-carousel"
         >
            <div class="carousel-content">
               <atlantis-contact-card-with-button
                  internalClassName=${classNames(
                     'shadow-none',
                     this.internalClassName
                  )}
                  avatar=${ifDefined(this.avatar)}
                  cardTitle=${ifDefined(this.cardTitle)}
                  initials=${this.initials}
                  contact-mail=${this.contactMail}
                  contact-name=${this.contactName}
                  contact-position=${this.contactPosition}
                  .hasViewTeamCallback=${this.hasViewTeamCallback}
                  ?fixedSize=${this.fixedSize}
               >
               </atlantis-contact-card-with-button>
            </div>
            <slot name="paginationSlot"></slot>
         </div>
      `;
   }
}
